import * as React from 'react';

import { Modal } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import { ReactComponent as WarningExclamation } from 'assets/big-warning-exclamation.svg';
import styled from '@emotion/styled';
import { colors } from 'styles/colors';
import { SoloButton } from './SoloButton';
import './ConfirmationModal.css';
import { useState } from 'react';
import { SoloFormMetadata } from './SoloFormField';
import { Formik, useFormikContext } from 'formik';

const maskStyle = {
  background: 'rgba(255, 255, 255, 0)'
};
const floatingStyle = {
  borderRadius: '10px'
};
const bodyStyle = {
  borderRadius: '10px'
};

interface UnderlineButtonProps {
  text: string;
  onClick: (e: React.MouseEvent<any, MouseEvent>) => void;
}
const UnderlineButton = (props: UnderlineButtonProps) => {
  const { text, onClick } = props;
  return (
    <button className='underline-button' onClick={onClick}>
      {text}
    </button>
  );
};

interface Props extends ModalProps {
  goForIt: (metadata: [string, string][]) => any;
  cancel: () => any;
  visible?: boolean;
  isNegative?: boolean;
}

export interface CreateAPIKeyValues {
  apiKeyMetadata?: [string, string][];
  newAPIKeyMetadataKey?: string;
  newAPIKeyMetadataValue?: string;
}

export const CreateAPIKeyModal = (props: Props) => {
  const closeModal = (): void => {
    props.cancel();
  };
  const [isConfigVisible, setIsConfigVisible] = useState(false);
  const toggleConfigVisible = () => {
    setIsConfigVisible(!isConfigVisible);
  };

  const { goForIt, isNegative } = props;

  const initialValues: CreateAPIKeyValues = {
    apiKeyMetadata: [],
    newAPIKeyMetadataKey: '',
    newAPIKeyMetadataValue: ''
  };

  return (
    <>
      <Modal
        visible={props.visible}
        footer={null}
        onCancel={closeModal}
        width={360}
        maskStyle={maskStyle}
        style={floatingStyle}
        bodyStyle={bodyStyle}>
        <div className='content-container'>
          <div className='warning-circle'>
            <WarningExclamation />
          </div>
          <div className='content-text'>Are you sure you want to generate a new key?</div>

          <Formik<CreateAPIKeyValues>
            initialValues={initialValues}
            onSubmit={values => goForIt(values.apiKeyMetadata ?? [])}>
            {({ isSubmitting, handleSubmit, errors, dirty, values, touched, setFieldValue, resetForm }) => (
              <>
                <div className='button-group'>
                  <SoloButton
                    onClick={handleSubmit}
                    text='Generate Key'
                    isNegative={isNegative}
                    disabled={isSubmitting}
                  />
                </div>

                <div className='configure'>
                  <UnderlineButton text='Configure Key?' onClick={toggleConfigVisible} />
                  {isConfigVisible && (
                    <div className='metadata-group'>
                      <SoloFormMetadata<CreateAPIKeyValues>
                        name='apiKeyMetadata'
                        newMetadataKey='newAPIKeyMetadataKey'
                        newMetadataValue='newAPIKeyMetadataValue'
                      />
                    </div>
                  )}
                </div>
              </>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  );
};
